/**
 * Country Flag Helper
 * Centralized utility for getting country flag emojis by country code
 */

export const getCountryFlag = (countryCode: string): string => {
  // Comprehensive country code to flag emoji mapping
  const flagMap: { [key: string]: string } = {
    // Major trading partners
    'CN': '🇨🇳', 'US': '🇺🇸', 'VN': '🇻🇳', 'IN': '🇮🇳', 'MX': '🇲🇽',
    'TH': '🇹🇭', 'MY': '🇲🇾', 'TW': '🇹🇼', 'KR': '🇰🇷', 'ID': '🇮🇩', 'PH': '🇵🇭',
    
    // Europe
    'DE': '🇩🇪', 'FR': '🇫🇷', 'IT': '🇮🇹', 'ES': '🇪🇸', 'GB': '🇬🇧', 'UK': '🇬🇧',
    'NL': '🇳🇱', 'BE': '🇧🇪', 'CH': '🇨🇭', 'AT': '🇦🇹', 'SE': '🇸🇪', 'NO': '🇳🇴',
    'DK': '🇩🇰', 'FI': '🇫🇮', 'PL': '🇵🇱', 'CZ': '🇨🇿', 'HU': '🇭🇺', 'RO': '🇷🇴',
    'BG': '🇧🇬', 'HR': '🇭🇷', 'SI': '🇸🇮', 'SK': '🇸🇰', 'EE': '🇪🇪', 'LV': '🇱🇻',
    'LT': '🇱🇹', 'IE': '🇮🇪', 'PT': '🇵🇹', 'GR': '🇬🇷', 'MT': '🇲🇹',
    'LU': '🇱🇺', 'IS': '🇮🇸', 'RS': '🇷🇸', 'BA': '🇧🇦', 'ME': '🇲🇪', 'MK': '🇲🇰',
    'AL': '🇦🇱', 'MD': '🇲🇩', 'UA': '🇺🇦', 'BY': '🇧🇾', 'RU': '🇷🇺',
    
    // Asia Pacific
    'JP': '🇯🇵', 'AU': '🇦🇺', 'NZ': '🇳🇿', 'SG': '🇸🇬', 'HK': '🇭🇰', 'MO': '🇲🇴',
    'BD': '🇧🇩', 'LK': '🇱🇰', 'PK': '🇵🇰', 'AF': '🇦🇫', 'NP': '🇳🇵', 'BT': '🇧🇹',
    'MM': '🇲🇲', 'KH': '🇰🇭', 'LA': '🇱🇦', 'BN': '🇧🇳', 'MV': '🇲🇻', 'FJ': '🇫🇯',
    'PG': '🇵🇬', 'SB': '🇸🇧', 'VU': '🇻🇺', 'NC': '🇳🇨', 'PF': '🇵🇫', 'WS': '🇼🇸',
    'TO': '🇹🇴', 'TV': '🇹🇻', 'KI': '🇰🇮', 'NR': '🇳🇷', 'PW': '🇵🇼', 'FM': '🇫🇲',
    'MH': '🇲🇭', 'MP': '🇲🇵', 'GU': '🇬🇺', 'AS': '🇦🇸',
    
    // Middle East
    'SA': '🇸🇦', 'AE': '🇦🇪', 'QA': '🇶🇦', 'KW': '🇰🇼', 'BH': '🇧🇭', 'OM': '🇴🇲',
    'JO': '🇯🇴', 'LB': '🇱🇧', 'SY': '🇸🇾', 'IQ': '🇮🇶', 'IR': '🇮🇷', 'IL': '🇮🇱',
    'PS': '🇵🇸', 'TR': '🇹🇷', 'CY': '🇨🇾', 'GE': '🇬🇪', 'AM': '🇦🇲', 'AZ': '🇦🇿',
    'YE': '🇾🇪',
    
    // Africa
    'ZA': '🇿🇦', 'EG': '🇪🇬', 'NG': '🇳🇬', 'KE': '🇰🇪', 'ET': '🇪🇹', 'GH': '🇬🇭',
    'MA': '🇲🇦', 'TN': '🇹🇳', 'DZ': '🇩🇿', 'LY': '🇱🇾', 'SD': '🇸🇩', 'SS': '🇸🇸',
    'UG': '🇺🇬', 'TZ': '🇹🇿', 'RW': '🇷🇼', 'BI': '🇧🇮', 'DJ': '🇩🇯', 'SO': '🇸🇴',
    'ER': '🇪🇷', 'MG': '🇲🇬', 'MU': '🇲🇺', 'SC': '🇸🇨', 'KM': '🇰🇲', 'MZ': '🇲🇿',
    'ZW': '🇿🇼', 'ZM': '🇿🇲', 'MW': '🇲🇼', 'BW': '🇧🇼', 'NA': '🇳🇦', 'SZ': '🇸🇿',
    'LS': '🇱🇸', 'AO': '🇦🇴', 'CD': '🇨🇩', 'CG': '🇨🇬', 'CF': '🇨🇫', 'CM': '🇨🇲',
    'TD': '🇹🇩', 'NE': '🇳🇪', 'BF': '🇧🇫', 'ML': '🇲🇱', 'SN': '🇸🇳', 'GM': '🇬🇲',
    'GW': '🇬🇼', 'GN': '🇬🇳', 'SL': '🇸🇱', 'LR': '🇱🇷', 'CI': '🇨🇮', 'BJ': '🇧🇯',
    'TG': '🇹🇬', 'GQ': '🇬🇶', 'GA': '🇬🇦', 'ST': '🇸🇹', 'CV': '🇨🇻',
    
    // Americas
    'CA': '🇨🇦', 'XQ': '🇨🇦', 'BR': '🇧🇷', 'AR': '🇦🇷', 'CL': '🇨🇱', 'PE': '🇵🇪', 'CO': '🇨🇴',
    'VE': '🇻🇪', 'EC': '🇪🇨', 'BO': '🇧🇴', 'PY': '🇵🇾', 'UY': '🇺🇾', 'GY': '🇬🇾',
    'SR': '🇸🇷', 'GF': '🇬🇫', 'GT': '🇬🇹', 'BZ': '🇧🇿', 'SV': '🇸🇻',
    'HN': '🇭🇳', 'NI': '🇳🇮', 'CR': '🇨🇷', 'PA': '🇵🇦', 'CU': '🇨🇺', 'JM': '🇯🇲',
    'HT': '🇭🇹', 'DO': '🇩🇴', 'PR': '🇵🇷', 'VI': '🇻🇮', 'AG': '🇦🇬', 'DM': '🇩🇲',
    'LC': '🇱🇨', 'VC': '🇻🇨', 'GD': '🇬🇩', 'BB': '🇧🇧', 'TT': '🇹🇹', 'KN': '🇰🇳',
    'BS': '🇧🇸', 'TC': '🇹🇨', 'KY': '🇰🇾', 'BM': '🇧🇲', 'GL': '🇬🇱', 'PM': '🇵🇲',
    'MQ': '🇲🇶', 'GP': '🇬🇵', 'BL': '🇧🇱', 'MF': '🇲🇫', 'SX': '🇸🇽', 'CW': '🇨🇼',
    'AW': '🇦🇼', 'BQ': '🇧🇶',
    
    // Central Asia
    'KZ': '🇰🇿', 'UZ': '🇺🇿', 'TM': '🇹🇲', 'TJ': '🇹🇯', 'KG': '🇰🇬', 'MN': '🇲🇳',
    
    // Additional territories and regions
    'HM': '🇭🇲', 'BV': '🇧🇻', 'SJ': '🇸🇯', 'UM': '🇺🇲', 'AQ': '🇦🇶', 'TF': '🇹🇫',
    'IO': '🇮🇴', 'CC': '🇨🇨', 'CX': '🇨🇽', 'NF': '🇳🇫', 'PN': '🇵🇳', 'SH': '🇸🇭',
    'TA': '🇹🇦', 'AC': '🇦🇨', 'WF': '🇼🇫', 'RE': '🇷🇪', 'YT': '🇾🇹', 'MS': '🇲🇸',
    'AI': '🇦🇮', 'VG': '🇻🇬', 'FK': '🇫🇰', 'GS': '🇬🇸',
  };
  
  return flagMap[countryCode.toUpperCase()] || '🌍';
};

/**
 * Gets a list of all supported country codes
 */
export const getSupportedCountryCodes = (): string[] => {
  return Object.keys({
    // Major trading partners
    'CN': '🇨🇳', 'US': '🇺🇸', 'VN': '🇻🇳', 'IN': '🇮🇳', 'MX': '🇲🇽',
    'TH': '🇹🇭', 'MY': '🇲🇾', 'TW': '🇹🇼', 'KR': '🇰🇷', 'ID': '🇮🇩', 'PH': '🇵🇭',
    
    // Europe
    'DE': '🇩🇪', 'FR': '🇫🇷', 'IT': '🇮🇹', 'ES': '🇪🇸', 'GB': '🇬🇧', 'UK': '🇬🇧',
    'NL': '🇳🇱', 'BE': '🇧🇪', 'CH': '🇨🇭', 'AT': '🇦🇹', 'SE': '🇸🇪', 'NO': '🇳🇴',
    'DK': '🇩🇰', 'FI': '🇫🇮', 'PL': '🇵🇱', 'CZ': '🇨🇿', 'HU': '🇭🇺', 'RO': '🇷🇴',
    'BG': '🇧🇬', 'HR': '🇭🇷', 'SI': '🇸🇮', 'SK': '🇸🇰', 'EE': '🇪🇪', 'LV': '🇱🇻',
    'LT': '🇱🇹', 'IE': '🇮🇪', 'PT': '🇵🇹', 'GR': '🇬🇷', 'MT': '🇲🇹',
    'LU': '🇱🇺', 'IS': '🇮🇸', 'RS': '🇷🇸', 'BA': '🇧🇦', 'ME': '🇲🇪', 'MK': '🇲🇰',
    'AL': '🇦🇱', 'MD': '🇲🇩', 'UA': '🇺🇦', 'BY': '🇧🇾', 'RU': '🇷🇺',
    
    // Asia Pacific
    'JP': '🇯🇵', 'AU': '🇦🇺', 'NZ': '🇳🇿', 'SG': '🇸🇬', 'HK': '🇭🇰', 'MO': '🇲🇴',
    'BD': '🇧🇩', 'LK': '🇱🇰', 'PK': '🇵🇰', 'AF': '🇦🇫', 'NP': '🇳🇵', 'BT': '🇧🇹',
    'MM': '🇲🇲', 'KH': '🇰🇭', 'LA': '🇱🇦', 'BN': '🇧🇳', 'MV': '🇲🇻', 'FJ': '🇫🇯',
    'PG': '🇵🇬', 'SB': '🇸🇧', 'VU': '🇻🇺', 'NC': '🇳🇨', 'PF': '🇵🇫', 'WS': '🇼🇸',
    'TO': '🇹🇴', 'TV': '🇹🇻', 'KI': '🇰🇮', 'NR': '🇳🇷', 'PW': '🇵🇼', 'FM': '🇫🇲',
    'MH': '🇲🇭', 'MP': '🇲🇵', 'GU': '🇬🇺', 'AS': '🇦🇸',
    
    // Middle East
    'SA': '🇸🇦', 'AE': '🇦🇪', 'QA': '🇶🇦', 'KW': '🇰🇼', 'BH': '🇧🇭', 'OM': '🇴🇲',
    'JO': '🇯🇴', 'LB': '🇱🇧', 'SY': '🇸🇾', 'IQ': '🇮🇶', 'IR': '🇮🇷', 'IL': '🇮🇱',
    'PS': '🇵🇸', 'TR': '🇹🇷', 'CY': '🇨🇾', 'GE': '🇬🇪', 'AM': '🇦🇲', 'AZ': '🇦🇿',
    'YE': '🇾🇪',
    
    // Africa
    'ZA': '🇿🇦', 'EG': '🇪🇬', 'NG': '🇳🇬', 'KE': '🇰🇪', 'ET': '🇪🇹', 'GH': '🇬🇭',
    'MA': '🇲🇦', 'TN': '🇹🇳', 'DZ': '🇩🇿', 'LY': '🇱🇾', 'SD': '🇸🇩', 'SS': '🇸🇸',
    'UG': '🇺🇬', 'TZ': '🇹🇿', 'RW': '🇷🇼', 'BI': '🇧🇮', 'DJ': '🇩🇯', 'SO': '🇸🇴',
    'ER': '🇪🇷', 'MG': '🇲🇬', 'MU': '🇲🇺', 'SC': '🇸🇨', 'KM': '🇰🇲', 'MZ': '🇲🇿',
    'ZW': '🇿🇼', 'ZM': '🇿🇲', 'MW': '🇲🇼', 'BW': '🇧🇼', 'NA': '🇳🇦', 'SZ': '🇸🇿',
    'LS': '🇱🇸', 'AO': '🇦🇴', 'CD': '🇨🇩', 'CG': '🇨🇬', 'CF': '🇨🇫', 'CM': '🇨🇲',
    'TD': '🇹🇩', 'NE': '🇳🇪', 'BF': '🇧🇫', 'ML': '🇲🇱', 'SN': '🇸🇳', 'GM': '🇬🇲',
    'GW': '🇬🇼', 'GN': '🇬🇳', 'SL': '🇸🇱', 'LR': '🇱🇷', 'CI': '🇨🇮', 'BJ': '🇧🇯',
    'TG': '🇹🇬', 'GQ': '🇬🇶', 'GA': '🇬🇦', 'ST': '🇸🇹', 'CV': '🇨🇻',
    
    // Americas
    'CA': '🇨🇦', 'XQ': '🇨🇦', 'BR': '🇧🇷', 'AR': '🇦🇷', 'CL': '🇨🇱', 'PE': '🇵🇪', 'CO': '🇨🇴',
    'VE': '🇻🇪', 'EC': '🇪🇨', 'BO': '🇧🇴', 'PY': '🇵🇾', 'UY': '🇺🇾', 'GY': '🇬🇾',
    'SR': '🇸🇷', 'GF': '🇬🇫', 'GT': '🇬🇹', 'BZ': '🇧🇿', 'SV': '🇸🇻',
    'HN': '🇭🇳', 'NI': '🇳🇮', 'CR': '🇨🇷', 'PA': '🇵🇦', 'CU': '🇨🇺', 'JM': '🇯🇲',
    'HT': '🇭🇹', 'DO': '🇩🇴', 'PR': '🇵🇷', 'VI': '🇻🇮', 'AG': '🇦🇬', 'DM': '🇩🇲',
    'LC': '🇱🇨', 'VC': '🇻🇨', 'GD': '🇬🇩', 'BB': '🇧🇧', 'TT': '🇹🇹', 'KN': '🇰🇳',
    'BS': '🇧🇸', 'TC': '🇹🇨', 'KY': '🇰🇾', 'BM': '🇧🇲', 'GL': '🇬🇱', 'PM': '🇵🇲',
    'MQ': '🇲🇶', 'GP': '🇬🇵', 'BL': '🇧🇱', 'MF': '🇲🇫', 'SX': '🇸🇽', 'CW': '🇨🇼',
    'AW': '🇦🇼', 'BQ': '🇧🇶',
    
    // Central Asia
    'KZ': '🇰🇿', 'UZ': '🇺🇿', 'TM': '🇹🇲', 'TJ': '🇹🇯', 'KG': '🇰🇬', 'MN': '🇲🇳',
    
    // Additional territories and regions
    'HM': '🇭🇲', 'BV': '🇧🇻', 'SJ': '🇸🇯', 'UM': '🇺🇲', 'AQ': '🇦🇶', 'TF': '🇹🇫',
    'IO': '🇮🇴', 'CC': '🇨🇨', 'CX': '🇨🇽', 'NF': '🇳🇫', 'PN': '🇵🇳', 'SH': '🇸🇭',
    'TA': '🇹🇦', 'AC': '🇦🇨', 'WF': '🇼🇫', 'RE': '🇷🇪', 'YT': '🇾🇹', 'MS': '🇲🇸',
    'AI': '🇦🇮', 'VG': '🇻🇬', 'FK': '🇫🇰', 'GS': '🇬🇸',
  });
};

/**
 * Checks if a country code has a flag emoji
 */
export const hasCountryFlag = (countryCode: string): boolean => {
  return getSupportedCountryCodes().includes(countryCode.toUpperCase());
}; 